const VIDEO_EXTENSION = /\.(mp4|m4v|mov|webm|mkv|ts|mts|m2ts|avi|3gp|ogv)$/i;

/** File input `accept` for videos; MKV/MOV often come without a MIME type. */
export const VIDEO_ACCEPT = 'video/*,.mkv,.mov,.m4v,.webm,.ts,.mts,.m2ts';

/** Video-like files only. */
export function pickVideoFiles(files: FileList | readonly File[] | null | undefined): File[] {
  if (!files) return [];
  return Array.from(files).filter((file) => file.type.startsWith('video/') || VIDEO_EXTENSION.test(file.name));
}

/** Runs a DOM update inside a view transition where supported. */
export function withViewTransition(update: () => void): void {
  const start = (document as Document & { startViewTransition?: (callback: () => void) => unknown }).startViewTransition;
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  if (start && !reduced) start.call(document, update);
  else update();
}
